import React, { Component } from 'react';

class CustomTooltip  extends Component{
    constructor(props){
        super(props);
        this.createIcon = this.createIcon.bind(this);
        this.state = {
            index: 0
        }
    }       
    
    createIcon(string, color) { 
        let cadena = string.toString().replace(/green/g, color);
        return {__html: cadena};
    };

    renderTooltip(){
        const {  payload, colors} = this.props;      
                       
        return (
            <div className="custom-tooltip">
                <p className="custom-tooltip-title" >{payload[0].payload.name}</p>
                <p style={{color:colors[1]}}>{'am: ' + payload[0].payload.am}</p>
                <p style={{color:colors[0]}}>{'pm: ' + (-payload[0].payload.pm)}</p>            
            </div>
        )
    }
  
    render() {
        const { active } = this.props;
        if (active) {
            return (
                this.renderTooltip()
            )
        }  
        return null;
    }
}

export default CustomTooltip;